/**
 * PDF の表セクションのスタイル定義。
 * 画面側の表（components/reportResult/TableSection/styles.ts）と
 * gridレイアウトPDFの表に見た目を合わせつつ、@react-pdf/renderer 向けに px・配色を調整している。
 */
import { gray, red, white } from '@kmns-internal/furikake/tokens'
import { StyleSheet } from '@react-pdf/renderer'

/** 行番号列の幅（px） */
const ROW_NUMBER_WIDTH = 24
/** データ列の幅（px）。gridレイアウトPDFに合わせて固定にしている */
const CELL_WIDTH = 64

/** 全セル共通の寸法・フォント・ボーダー（幅・背景を除く） */
const cellBase = {
  padding: 4,
  fontSize: 8,
  textAlign: 'center',
  borderRight: `1px solid ${gray[3]}`,
  borderBottom: `1px solid ${gray[3]}`,
} as const

export const tableStyles = StyleSheet.create({
  sectionWrap: {
    marginTop: 5,
    marginBottom: 5,
  },
  sectionName: {
    fontSize: 10,
    fontWeight: 700,
    marginBottom: 3,
  },
  row: {
    flexDirection: 'row',
  },
  /** ヘッダー行の先頭セル（左上の空セル） */
  headerFirstCell: {
    ...cellBase,
    width: ROW_NUMBER_WIDTH,
    backgroundColor: gray[1],
  },
  /** ヘッダー（列名）セル */
  headerCell: {
    ...cellBase,
    width: CELL_WIDTH,
    fontWeight: 700,
    backgroundColor: white,
    borderTop: `1px solid ${gray[3]}`,
    borderBottom: `2px solid ${gray[3]}`,
  },
  /** 本体行の先頭セル（行番号） */
  bodyFirstCell: {
    ...cellBase,
    width: ROW_NUMBER_WIDTH,
    backgroundColor: white,
    color: gray[6],
    borderLeft: `1px solid ${gray[3]}`,
  },
  headerRowHeadingCell: {
    ...cellBase,
    width: CELL_WIDTH,
    fontWeight: 700,
    backgroundColor: white,
    borderTop: `1px solid ${gray[3]}`,
    borderBottom: `2px solid ${gray[3]}`,
  },
  bodyRowHeadingCell: {
    ...cellBase,
    width: CELL_WIDTH,
    backgroundColor: white,
    color: gray[9],
  },
  /** 本体セル */
  bodyCell: {
    ...cellBase,
    width: CELL_WIDTH,
    backgroundColor: white,
    color: gray[9],
  },
  /** 条件を満たさない分岐セル（「ー」表示） */
  inactiveCell: {
    color: gray[5],
  },
  /** 逸脱（不正回答）セル */
  invalidCell: {
    backgroundColor: red[0],
    color: red[6],
  },
  /** 「該当なし」セル（灰色 + 横線） */
  noAnswerCell: {
    padding: 0,
    backgroundColor: gray[1],
    justifyContent: 'center',
  },
  noAnswerLine: {
    height: 1,
    backgroundColor: gray[3],
  },
  /** 未回答セル */
  unansweredCell: {
    color: gray[5],
  },
  requiredDot: {
    color: red[6],
  },
  signatureImage: {
    height: 18,
    objectFit: 'contain',
  },
})
